interface FilterUniqueOptions {
    exact?: boolean;
}

/**
 * Filters values in an array to be unique
 *
 * @param options - The options
 * @param options.exact - Should we use === or ==
 * @returns - The filter function
 */
export function filterUnique<T>(options?: FilterUniqueOptions): (value: T, index: number, arr: T[]) => boolean {
    const { exact = true } = options ?? {};
    if (exact) {
        return (value, index, arr) => arr.indexOf(value) === index;
    } else {
        // eslint-disable-next-line id-length, eqeqeq
        return (value, index, arr) => arr.findIndex(v => v == value) === index;
    }
}
